import Vue from 'vue';
import api from '../../api/location'
import Utils from './base.js';
//import CONFIG from '@/constants/config.js';

const state = {
  locations:[],
  locations_all:[],
  location_loading:false,
  location_error:false,
  apiLoading:false
}

// getters
const getters = {
  firstLocation:state => {
    return (state.locations && state.locations.length>0)?Vue._.first(state.locations):null
  },
  firstXLocations:state =>(count)=> {
    return Vue._.slice(state.locations_all,0,count);
  },
  allLocations:state=>{
    return state.locations_all;
  }
}

// actions
const actions = {
  getLocations ({ commit },data) {
    commit('SET_LOCATION_LOADING', true);
    return new Promise((resolve, reject) => {
      api.getLocations(data).then(response=>{
        if(response && response.data){
          commit('SET_LOCATIONS', response.data);
          resolve(response.data);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_LOCATION_LOADING', false);
      })
    })
  },

  //Requests location by id. Cation: Cache enabled
  getLocationById ({ commit },id) {

    commit('SET_LOCATION_LOADING', true);
    return new Promise((resolve, reject) => {
      if(null!=id){
        //Search in cached files
        let item= Utils.getBy('id',state.locations_all,id);
        if(!Vue._.isEmpty(item)){
          resolve(item);
        }else{
          //Request server
          api.getLocationById(id).then(response=>{
            if(response && response.data){
              resolve(response.data);
            }else{
              reject(null);
            }
          }).catch(error=>{
            reject(error);
          }).finally(()=>{
            commit('SET_LOCATION_LOADING', false);
          })
        }
      }else{
        reject(null);
      }
    })
  },

  getMyLocations ({ commit },model) {

    commit('SET_LOCATION_LOADING', true);
    return new Promise((resolve, reject) => {
      api.getMyLocations(model.userId,model.data).then(response=>{

        if(response && response.data){
          let modifiedResponseData=(Vue._.isArray(response.data))?response.data:[response.data];
          commit('SET_MY_LOCATIONS', modifiedResponseData);
          resolve(modifiedResponseData);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_LOCATION_LOADING', false);
      })
    })
  },
  createLocation ({ commit },location) {
    commit('SET_LOCATION_ERROR', false);
    commit('SET_LOCATION_LOADING', true);

    //TODO wenn es eine id hat, dann update

    return new Promise((resolve, reject) => {
      api.createLocation(location).then(response=>{
       
        if(response && response.data){

          //Update location by server id
          if(null==location.id){
            let newId={id:response.data.id};
            let updateModel={
              location:location,
              data:newId
            };
            commit('UPDATE_LOCATION',updateModel);
          }
          //TODO: else here

          commit('ADD_LOCATION', response.data);
          resolve(response.data);
        }else{
          reject(null);
        }
       
      }).catch(error=>{
        commit('SET_LOCATION_ERROR', true);
        reject(error);
      }).finally(()=>{
        commit('SET_LOCATION_LOADING', false);
      })
    })
  },
  deleteLocation ({ commit },location) {
    commit('SET_LOCATION_LOADING', true);
    return new Promise((resolve, reject) => {
      api.deleteLocation().then(response=>{
        if(response && response.data){
          resolve(response);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('DELETE_LOCATION', location);
        commit('SET_LOCATION_LOADING', false);
      })
    })
  },
  finishLocation ({ commit },location) {
    commit('SET_LOCATION_LOADING', true);
    return new Promise((resolve, reject) => {
      api.finishLocation(location).then(response=>{
        if(response && response.data){
          resolve(response);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_LOCATION_LOADING', false);
      })
    })
  },
  checkPricing ({ commit },price) {
    commit('SET_API_LOADING', true);
    return new Promise((resolve, reject) => {
      api.checkPricing(price).then(response=>{
        if(response && response.data){
          resolve(response.data);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_API_LOADING', false);
      })
    })
  },
  destroy({commit}){
    commit('SET_MY_LOCATIONS', []);
  }
}

// mutations
const mutations = {

  SET_LOCATIONS(state, locations) {
    //TODO MERGE WENN PAGING
    let newEntries=(Vue._.isArray(locations))?locations:[];
    Vue.set(state,'locations_all',newEntries);
  },

  SET_MY_LOCATIONS(state, locations) {
    let newEntries=(Vue._.isArray(locations))?locations:[];
    Vue.set(state,'locations',newEntries);
  },

  ADD_LOCATION (state, location) {
    if(!Vue._.isEmpty(location)){
      let index=Utils.getIndexById(state.locations,location.id);
      if(index>-1){
        Vue.set(state.locations, index,location);
      }else{
        state.locations.push(location);
      }
    }
  },
  DELETE_LOCATION (state, location) {
    if(!Vue._.isEmpty(location)){
      let index=Utils.getIndexById(state.locations,location.id);
      if(index>-1){
        Vue.delete(state.locations, index)
      }
    }
  },
  UPDATE_LOCATION(state,updateData){

    if(!Vue._.isEmpty(updateData) && updateData.location){

      let index=Utils.getIndexById(state.locations,updateData.location.id);
      if(index>-1){
        updateData.data=(updateData.data)?updateData.data:{};
        //Merge and override array
        Vue.set(state.locations, index,Vue._.mergeWith(updateData.location,updateData.data,(objValue, srcValue)=>{
          if (Vue._.isArray(srcValue)) {
            return objValue = srcValue;
          }
        }));
      }
    }
  },
  SET_LOCATION_LOADING(state,val){
      Vue.set(state,'location_loading',val);
  },
  SET_LOCATION_ERROR(state,val){
    Vue.set(state,'location_error',val);
  },
  SET_API_LOADING(state,val){
    Vue.set(state,'api_loading',val);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}